export const RewardsDashboardErrors = {
  TOKEN_UNDEFINED: {
    code: 'RD0001',
    message: 'Access and/or ID token is undefined',
  },
};
